import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";

// custome hooks
import usePriceSeprator from "../../../hooks/usePriceSeparator";

import { useLocation } from "react-router-dom";

// components
import HomeNavbar from "../HomeNavbar/HomeNavbar";
import Footer from "../Footer/Footer";

// styles
// import styles from "./UserFilesToShow.module.css"
import Dstyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";
import LandingHeader from "./LandingsHeader";
import Estates from "../UserFilesToShow/Card/Estates";
import { UserContext } from "../../Context/UserContextProvider";
import axios from "axios";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Pagination, Stack } from "@mui/material";
import CustomPagination from "../../CustomPagination/CustomPagination";

const Landings = () => {
  let { link } = useParams();
  const { state } = useLocation();
  const [query, setQuery] = useState("");
  const [estatesData, setEstatesData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 1,
  });
  let [landingId, setLandingId] = useState(0);
  let [landingTitle, setLandingTitle] = useState("");
  let [landingDescription, setLandingDescription] = useState("");

  useEffect(() => {
    axios.get("Landing/ByLink?link=" + link).then(res => {
      setLandingId(res.data.id);
      setLandingTitle(res.data.title);
      setLandingDescription(res.data.description);

      axios.get(`Estate/Landing?take=12&page=${page.pageNumber}&id=` + res.data.id).then(res => {
        setEstatesData(res.data.data.data || []);
        setIsLoading(false);
        setPage(prev => {
          return { ...prev, pageCount: res.data.data.pageCount };
        });
      });
    });
  }, []);

  function reloadData(ev, value) {
    console.log("I got called");

    axios.get("Landing/ByLink?link=" + link).then(res => {
      setLandingId(res.data.id);
      setLandingTitle(res.data.title);
      setLandingDescription(res.data.description);

      axios.get(`Estate/Landing?take=12&page=${value}&id=` + res.data.id).then(res => {
        setEstatesData(res.data.data.data || []);
        setIsLoading(false);
        setPage({
          pageCount: res.data.data.pageCount,
          pageNumber: value,
        });
      });
    });
  }

  return (
    <>
      <Helmet>
        <title>آذر ملک | Azr Melk</title>
        <meta name="description" content="خرید و فروش ملک در تبریز" />
        <meta
          name="keywords"
          content="فروش آپارتمان مسکونی در تبریز, فروش آپارتمان در ولیعصر تبریز, فروش آپارتمان مسکونی در ولیعصر تبریز, فروش آپارتمان مسکونی در رشدیه  تبریز, فروش آپارتمان مسکونی در زعفرانیه  تبریز, فروش آپارتمان مسکونی در مرزداران  تبریز"
        />
        <meta content="index , follow" name="robots" />
        <meta name="description" content="خرید و فروش ملک در تبریز" />
      </Helmet>

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar navSale />
            <LandingHeader title={landingTitle} description={landingDescription}></LandingHeader>
            <section className="container py-3 px-0">
              <div className="w-100 d-flex justify-content-center flex-wrap align-items-center mt-3" dir="rtl">
                <Estates cardData={estatesData} usePriceSeprator={usePriceSeprator} saleCards={true} callConsultant pageNum={page.pageNumber} query={query} />
              </div>
            </section>
            <Stack
              className={Dstyles.pagination}
              spacing={1}
              sx={{
                direction: "ltr",
                bottom: "0",
                height: "85px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center !important",
              }}>
              {/* <Typography>Page: {page}</Typography> */}
              <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={reloadData} />
            </Stack>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(Landings);
